import { SelectOption } from '@tassat/common-definitions';
import { AddressBookRecord } from '@tassat/fred-definitions';
import { createSelector } from 'reselect';

import { getAddressBook } from './common';

//What? - gnoring contacts which are deleted.
//@TODO - Why is the deleted contact is sent by the server for the frontend to consume in the first place?
//Response should have no deleted record. May return a flag to indicate succes/failure when deleting a record.
export const getAddressBookContactsArray = createSelector(getAddressBook, (addressbook): AddressBookRecord[] => {
    return Object.keys(addressbook.contacts)
        .map(id => addressbook.contacts[id])
        .filter(contact => !contact.IsDeleted);
});

export const getAddressBookContacts = createSelector(getAddressBookContactsArray, (addressBookContacts): SelectOption[] => {
    return addressBookContacts
        .map(contact => {
            return ({
                label: contact.NickName ?
                    `${contact.NickName}`
                    : `${contact.AccountName}`,
                value: contact
            });
        })
        .sort((a, b) => {
            if (a.value.IsFavorite !== b.value.IsFavorite) {
                return a.value.IsFavorite ? -1 : 1;
            }

            return a.label.localeCompare(b.label);
        });
});